import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { SiSoundcloud } from "react-icons/si";
import { ASSOCIATED_WORKS } from "@/data/site";

export default function AssociatedWorks({ embedded = false }) {
  return (
    <div data-testid="works-page" className={embedded ? "" : "pt-16"}>
      <section className="bg-sage py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <h2 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-none text-ink mb-12">
            Associated Works
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ASSOCIATED_WORKS.map((w, i) => (
              <motion.a
                key={i}
                href={w.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5 }}
                data-testid={`work-${i}`}
                className="group block rounded-3xl overflow-hidden bg-cream border border-teal/30 transition-all duration-300 hover:shadow-lg"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={w.image}
                    alt={`${w.title} artwork`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute inset-0 flex items-center justify-center bg-ink/30 group-hover:bg-ink/20 transition-colors duration-300">
                    <span className="h-16 w-16 rounded-full bg-cream/90 text-ink flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Play size={26} fill="currentColor" />
                    </span>
                  </span>
                  <span className="absolute top-4 right-4 text-cream/90">
                    <SiSoundcloud size={26} />
                  </span>
                </div>

                <div className="p-6">
                  <p className="font-display text-xl text-ink leading-tight">{w.title}</p>
                  <p className="text-sm text-steel mt-1">{w.artist}</p>
                  <p className="text-xs uppercase tracking-[0.15em] text-terracotta font-semibold mt-4">
                    {w.credits}
                  </p>
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
